export default {
  vertical: 'vertical',
  horizontal: 'horizontal',
  listItem: 'listItem',
};
